export type OrderTrackingStage =
  | "all"
  | "project_pending"
  | "pr_pending"
  | "raw_inward_pending"
  | "print_outward_pending"
  | "print_inward_pending"
  | "dispatch_pending";

export interface OrderPipelineRow {
  order_id: number;
  order_created_date: string | null;
  project_created_date: string | null;
  order_type: string | null;
  customer_name: string | null;
  sales_poc: string | null;
  pm_poc: string | null;
  product_id: number;
  product_name: string | null;
  ordered_quantity: number;
  customisation_required: number;
  all_mockups_approved: number;
  last_mockup_approved_date: string | null;
  last_pr_date: string | null;
  pr_quantity: number;
  po_quantity: number;
  first_raw_inward_date: string | null;
  last_raw_inward_date: string | null;
  ri_total_received_quantity: number;
  ri_total_rejected_quantity: number;
  ri_qc_started: number;
  raw_inward_completed: number;
  po_total_quantity_sent: number;
  last_print_inward_date: string | null;
  printers: string | null;
  pi_total_received_quantity: number;
  pi_total_rejected_quantity: number;
  pi_qc_started: number;
  print_inward_completed: number;
  shipments_count: number;
  first_shipped_date: string | null;
  tat_project_approval_hours: number;
  tat_mockup_approval_hours: number;
  tat_pr_from_project_hours: number;
  tat_raw_inward_from_project_hours: number;
  tat_print_inward_from_project_hours: number;
  tat_print_inward_from_raw_inward_hours: number;
  tat_total_project_to_ship_hours: number;
}

export interface OrderTrackingStageSummaryItem {
  stage: OrderTrackingStage;
  label: string;
  count: number;
}

export interface OrderTrackingAverages {
  tat_project_approval_hours: number;
  tat_mockup_approval_hours: number;
  tat_pr_from_project_hours: number;
  tat_raw_inward_from_project_hours: number;
  tat_print_inward_from_project_hours: number;
  tat_print_inward_from_raw_inward_hours: number;
  tat_total_project_to_ship_hours: number;
}

export interface OrderTrackingAveragesResponse {
  averages: OrderTrackingAverages;
  stage_summary: OrderTrackingStageSummaryItem[];
}

export interface OrderTrackingPipelinePaginatedResponse {
  page_no: number;
  total_pages: number;
  total_count: number;
  list: OrderPipelineRow[];
  limit: number;
}

export const ORDER_TRACKING_STAGE_TABS: Array<{
  id: OrderTrackingStage;
  label: string;
}> = [
    { id: "all", label: "All" },
    { id: "project_pending", label: "Mockups Pending" },
    { id: "pr_pending", label: "PR Pending" },
    { id: "raw_inward_pending", label: "Raw Inward Pending" },
    { id: "print_outward_pending", label: "Print Outward Pending" },
    { id: "print_inward_pending", label: "Print Inward Pending" },
    { id: "dispatch_pending", label: "Dispatch Pending" },
  ];
